import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Button, H1, INLINE_COLORS, P, Span, Spinner } from 'shared';
import { usePutServicingV1InstrumentsInstrumentIdAutopaySettingsMutation } from 'servicing-api';
import { setAutopayCompleted, setPaymentOption } from '../../actions';
import { DisclosureFooter } from '../../components';
import { useAuthorizationToken, useFlexFinalizeData } from '../../hooks';
import { selectors } from '../../reducer';
import { getPathWithToken } from '../../utils';
import { PaymentOptionCard } from '../components';
const useStyles = makeStyles({
    tooltip: {
        backgroundColor: INLINE_COLORS.blackTooltip,
        color: INLINE_COLORS.whiteBase,
    },
});
function AutopayAuth() {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch();
    const authorizationToken = useAuthorizationToken();
    const { instrumentId, finalizeData, isLoading: isFinalizeLoading, } = useFlexFinalizeData(authorizationToken);
    const selectedBankAccount = useSelector((state) => selectors.selectedBankAccount(state));
    const storedPaymentOption = useSelector((state) => selectors.paymentOption(state));
    const isDI = !!finalizeData?.suggestedMonthlyPayment;
    const selectedPaymentOption = storedPaymentOption ?? (isDI ? 'suggested' : 'minimum');
    const handlePaymentOptionChange = (option) => {
        dispatch(setPaymentOption(option));
    };
    const [putAutopaySettings, { isLoading }] = usePutServicingV1InstrumentsInstrumentIdAutopaySettingsMutation();
    const selectedAmount = selectedPaymentOption === 'suggested'
        ? finalizeData?.suggestedMonthlyPayment
        : finalizeData?.monthlyPayment;
    const goToNextStep = async () => {
        if (instrumentId && selectedAmount) {
            try {
                await putAutopaySettings({
                    instrumentId: Number(instrumentId),
                    putServicingV1InstrumentsInstrumentIdAutopaySettings: {
                        autopayEnabled: true,
                        autopayAmount: selectedAmount,
                        autopayDayOfMonth: finalizeData?.estimatedFirstPaymentDate
                            ? parseInt(finalizeData.estimatedFirstPaymentDate.split('-')[2], 10)
                            : undefined,
                        paymentOption: selectedPaymentOption,
                    },
                }).unwrap();
                dispatch(setAutopayCompleted(true));
                history.push(getPathWithToken('/sign-agreement', authorizationToken));
            }
            catch (error) {
                // Handle error
            }
        }
        else {
            dispatch(setAutopayCompleted(true));
            history.push(getPathWithToken('/sign-agreement', authorizationToken));
        }
    };
    if (isFinalizeLoading || !finalizeData) {
        return (_jsx("div", { className: "pre-qualification-installment credit-portal pad-20", children: _jsx("div", { className: "text-center", children: _jsx(Spinner, {}) }) }));
    }
    return (_jsx("div", { className: "w100 flex justify-center align-center pad-20", children: _jsxs("div", { className: "payment-authorization-container flex dir-col justify-center", children: [_jsxs("div", { className: "flex dir-row", children: [_jsx(H1, { variant: "headline-large", children: "Set Up Autopay" }), _jsx(Tooltip, { placement: "top", enterTouchDelay: 0, classes: classes, title: _jsx(P, { variant: "body-small", className: "autopay-tooltip-text", children: "Autopay is not required but is strongly encouraged to ensure your payments are made on time and to avoid any potential late fees and keep your account in good standing." }), children: _jsx(IconButton, { className: "icon-button", children: _jsx(InfoIcon, { style: {
                                        background: INLINE_COLORS.blueMedium,
                                        color: INLINE_COLORS.whiteBase,
                                        borderRadius: '20px',
                                    } }) }) })] }), _jsxs("div", { className: "autopay-auth-content flex dir-col align-center", children: [_jsx(PaymentOptionCard, { selectedBankAccountNumber: selectedBankAccount?.accountId ||
                                finalizeData?.bankAccountLast4 ||
                                '', paymentSectionLabel: "Autopay", monthlyPayment: finalizeData?.monthlyPayment, suggestedMonthlyPayment: finalizeData?.suggestedMonthlyPayment, selectedPaymentOption: selectedPaymentOption, onPaymentOptionChange: handlePaymentOptionChange }), _jsx(Button, { type: "button", className: "button-primary button-warn button-warn-alp-flex w100", onClick: () => goToNextStep(), disabled: isLoading, children: isLoading ? _jsx(Spinner, { size: "small" }) : 'Set Up Autopay' }), _jsxs("div", { className: "w100 flex dir-row justify-center align-center mar-t-32", children: [_jsx("div", { className: "or-line" }), _jsx(Span, { variant: "title-medium", className: "color-gray mar-right-8 mar-left-8", children: "or" }), _jsx("div", { className: "or-line" })] }), _jsx(P, { variant: "title-small", className: "color-gray mar-t-32", children: "Don't want to set up monthly autopay?" }), _jsx(Link, { to: getPathWithToken('/autopay-auth/one-time-payment', authorizationToken), className: "mar-t-16", children: _jsx(Span, { bold: true, variant: "body-medium", className: "text-as-link", children: "Authorize First Payment" }) }), _jsx(DisclosureFooter, { termLength: finalizeData?.product?.termLength, loanAmount: finalizeData?.loanAmount, calculatedApr: finalizeData?.calculatedApr, promotionalPeriod: isDI ? finalizeData?.product?.promotionalPeriod : undefined })] })] }) }));
}
export default AutopayAuth;
